module.exports = __webpack_public_path__ + "img/corporate-responsibility-banner.ba42e4fa.png";